var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.8 22.8",
    style: {
      enableBackground: "new 0 0 26.8 22.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n\t.st1{fill:#F8AC59;}\n\t.st2{fill:#1AB394;}\n\t.st3{fill:#FF6666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_404_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_408_",
    className: "st0",
    d: "M7.2,15.2l3-1c0.9,1.7,2.8,2.9,4.9,2.9c1.1,0,2.1-0.3,3-0.9l2.8,3l1.7-1.6l-2.8-3 c0.6-0.9,0.9-1.9,0.9-3.1c0-1.2-0.4-2.3-1-3.2l1.5-1.5l-1.6-1.6L18,6.8C17.1,6.3,16.2,6,15.1,6C12,6,9.6,8.5,9.6,11.6 c0,0.2,0,0.3,0,0.5l-3.1,1L7.2,15.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_407_",
    className: "st1",
    cx: 3.8,
    cy: 15.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_406_",
    className: "st2",
    cx: 21.3,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_405_",
    className: "st3",
    cx: 23.3,
    cy: 19.4,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponents);
export default __webpack_public_path__ + "static/media/components.3ee5de8ed37cc70cdd3f744265a074f8.svg";
export { ForwardRef as ReactComponent };